"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "re": {
    "3da9c63f": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-cortaccio": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f67a985": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-lanca": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e306062": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-rovina": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c2d6d16": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-valle-degli-orti": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7fdf2836": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "skipSearch": false
    }],
    "folsogno": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4d3ebb4": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-ribellasca": [{
      "hkey": "533cfe4d",
      "slug": "re",
      "name": "Re",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;